<svg-icon
  #tooltipOnPreview="ngbTooltip"
  preserveAspectRatio="none"
  class="info-icon {{ colorType }}"
  [class.tooltip-opened]="tooltipOnPreview.isOpen()"
  [src]="'info-grey'"
  [stretch]="true"
  [ngbTooltip]="isTooltipTextTemplateRef() ? tooltipText : ($any(tooltipText) | translate)"
  [disableTooltip]="disableTooltip"
  [keepOnHover]="!shouldTriggerTooltipByClick || ensureKeepOnHover"
  [placement]="tooltipPosition"
  [triggers]="shouldTriggerTooltipByClick ? 'click' : undefined"
  [tooltipClass]="tooltipClass"
></svg-icon>
